export default __webpack_public_path__ + "static/media/6.dbea3fc6.png";